import axios from 'axios';
import Cookie from 'js-cookie';
import Vue from 'vue';
import { URL_APP } from '../api/urlApi';
import { removeUserInfo } from '@/services/auth/user';

const defaultOptions = {
  baseURL: URL_APP,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
};

export const httpClient = axios.create(defaultOptions);

httpClient.interceptors.request.use((config) => {
  const token = Cookie.get('token');
  config.headers['Authorization'] = token ? `Bearer ${token}` : '';
  return config;
});

httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status  = error?.response?.status;
    const data    = error?.response?.data;
    const message = data?.message || 'Ocorreu uma inconsistência.';

    if (status === 401 && Cookie.get('token')) {
      removeUserInfo();
      window.location.reload();
    } else if (status === 401) {
      Vue.toasted.error(`<b>Ops</b>&nbsp;&nbsp;${message}`);
    } else if (status === 403) {
      // ApiResponse coloca required_permission em data.data.required_permission
      const reqPerm = data?.data?.required_permission ?? data?.required_permission;
      const need = reqPerm ? ` (${reqPerm})` : '';
      Vue.toasted.error(`<b>Sem permissão</b>&nbsp;&nbsp;${message}${need}`);
    } else if (status === 422 && data?.errors) {
      const firstField = Object.values(data.errors)[0];
      const firstError = Array.isArray(firstField) ? firstField[0] : firstField;
      Vue.toasted.error(`<b>Dados inválidos</b>&nbsp;&nbsp;${firstError || message}`);
    } else if (status === 429) {
      Vue.toasted.error(`<b>Aguarde</b>&nbsp;&nbsp;Muitas tentativas, tente novamente em alguns segundos.`);
    } else {
      Vue.toasted.error(`<b>Erro</b>&nbsp;&nbsp;${message}`);
    }

    // Marca como já tratado pra suprimir o overlay de "unhandled rejection"
    // do webpack-dev-server. Callers que precisem do erro (ex: 422 inline)
    // continuam podendo usá-lo via try/catch normalmente.
    if (error) error._handled = true;
    return Promise.reject(error);
  }
);
